import React, { useEffect, useState } from "react";
import mail from "../assets/images/contact/mail.svg";
import fb from "../assets/images/contact/fb.svg";
import eye from "../assets/images/contact/eye.svg";
import AboutUsService from "../services/aboutUs";
import VisitService from "../services/visit";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo_kmutt.svg";
import { useParams } from "react-router-dom";

/** ลิงก์ social จาก Strapi ใช้ได้เฉพาะที่เป็น URL จริง ("-" หรือว่างถือว่าไม่มีลิงก์) */
const isUrl = (link) => /^https?:\/\//i.test(String(link || "").trim());

export default function Footer(props) {
  // social เอามาจากหน้า "ติดต่อเรา" (about-contact-us section = social)
  // จะได้ตั้งค่าใน Strapi ที่เดียวแล้วโชว์เหมือนกันทั้งสองที่
  let [socials, setSocials] = useState(null);
  let [visitCount, setVisitCount] = useState(null);

  let { lang } = useParams();

  useEffect(() => {
    getSocials();
    recordVisit();
  }, []);

  const getSocials = async () => {
    try {
      let res = await AboutUsService.getContact();
      const items = (res || [])
        .filter((contact) => contact.type === "social")
        .flatMap((contact) => contact.content || []);
      setSocials(items);
    } catch {
      console.error();
    }
  };

  const recordVisit = async () => {
    try {
      let total = await VisitService.record();
      setVisitCount(total);
    } catch {
      console.error();
    }
  };

  const socialCircle =
    "w-[40px] h-[40px] bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors overflow-hidden";

  function socialItem(item, i) {
    const url = item.image?.[0]?.url;
    const icon = url ? (
      <div
        className="w-full h-full !bg-center !bg-cover"
        style={{ background: `url(${process.env.REACT_APP_API_URL}${url}), #fff` }}
      />
    ) : null;

    return isUrl(item.link) ? (
      <a
        key={i}
        href={item.link.trim()}
        target="_blank"
        rel="noopener noreferrer"
        className={socialCircle}
        title={item.caption}
      >
        {icon}
      </a>
    ) : (
      <div key={i} className={socialCircle} title={item.caption}>
        {icon}
      </div>
    );
  }

  /** ยังไม่ได้ตั้งค่าใน Strapi / โหลดไม่ได้ ใช้ลิงก์เดิมไปก่อน footer จะได้ไม่ว่าง */
  const fallbackSocials = (
    <>
      <a href="https://www.facebook.com/HCU.KMUTT/?locale=th_TH" target="_blank" rel="noopener noreferrer" className={socialCircle}>
        <img className="w-[20px]" src={fb} alt="facebook" style={{ filter: 'brightness(0) invert(0)' }} />
      </a>
      <a href="mailto:hcu@kmutt.ac.th" className={socialCircle}>
        <img className="w-[20px]" src={mail} alt="email" style={{ filter: 'brightness(0) invert(0)' }} />
      </a>
    </>
  );

  return (
    <div id="footer">
      <div className="bg-slateGray section border-t-[4px] border-[#1CB5B1]">
        <div className="!z-[1] navbar-container flex flex-col lg:flex-row justify-between items-start gap-[50px] pt-[40px] pb-[40px]">
          {/* Left Side: Logo and Address */}
          <div className="flex-1">
            <Link to={`/${lang}`}>
              {/* แบบเว็บ sfa: โลโก้ | เส้นคั่น | ชื่อหน่วยงาน (ชิดขอบล่างโลโก้) */}
              <div className="flex items-end mb-[25px]">
                <img className="h-[50px] w-auto" src={logo} alt="" />
                <div className="w-[1px] h-[42px] bg-white/50 ml-[10px] mr-[12px] mb-[-2px]"></div>
                <div className="flex flex-col">
                  <p className="text-unit-footer text-white text-left font-normal">
                    กลุ่มงานบริการสุขภาพและอนามัย
                  </p>
                  <p className="text-unit-sub-footer mt-[6px] text-white text-left">
                    Health Care Unit
                  </p>
                </div>
              </div>
            </Link>
            
            <div className="text-white text-meta leading-none text-left flex flex-col gap-[6px] max-w-[500px]">
              <p>กลุ่มงานบริการสุขภาพและอนามัย มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี</p>
              <p>126 ถ.ประชาอุทิศ แขวงบางมด เขตทุ่งครุ กทม. 10140</p>
            </div>
          </div>

          {/* Right Side: Contact and Socials */}
          <div className="flex flex-col items-start lg:items-start gap-[15px] lg:min-w-[300px]">
            <div className="flex items-center gap-[10px] text-white text-body">
              <span className="font-semibold">Tel</span> 
              <span className="font-bold">0-2470-8446, 0-2470-8444</span>
            </div>
            
            {/* ยอดเข้าชมเว็บไซต์ (แทนเวลาทำการเดิม) */}
            <div className="flex items-center gap-[10px] text-white/80 text-body">
              <img className="w-[18px]" src={eye} alt="visitors" />
              <span>
                {lang === "en" ? "Visitors" : "ยอดเข้าชม"}{" "}
                <span className="font-bold text-white">
                  {visitCount === null ? "-" : visitCount.toLocaleString()}
                </span>
              </span>
            </div>

            <div className="mt-[10px]">
              <p className="text-white font-bold text-body mb-[15px]">Follow us</p>
              <div className="flex gap-[15px]">
                {socials && socials.length > 0
                  ? socials.map(socialItem)
                  : fallbackSocials}
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="bg-[#1CB5B1] w-full text-center text-white text-meta py-[4px]">
        Copyright © 2024 KMUTT, All rights reserved.
      </p>
    </div>
  );
}
